// @flow

import {Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ZeroDecimalCurrencies: MarkdocTagRegistration = {
  tag: 'zero-decimal-currencies',
  component: 'ZeroDecimalCurrencies',
  render(node, config) {
    const currencies = (config.variables.currencies: any);
    return new Tag(this.tag, {entries: currencies?.zero_decimal});
  },
};
